import {
    Chip,
    Stack,
    ToggleButton as MuiToggleButton,
    ToggleButtonGroup as MuiToggleButtonGroup,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { PlanPriceInterval } from '@/graphql/generated/types.generated';
import { PLANS_YEARLY_DISCOUNT } from '@/constants';

interface BillingIntervalToggleProps {
    value: PlanPriceInterval;
    onChange: (value: PlanPriceInterval) => void;
}

const ToggleButtonGroup = styled(MuiToggleButtonGroup)(({ theme }) => ({
    border: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.primary.main + '80',
    borderRadius: theme.spacing(1),
}));

const ToggleButton = styled(MuiToggleButton)(({ theme }) => ({
    color: theme.palette.text.secondary,
    textTransform: 'none',
    fontWeight: 600,
    '&.Mui-selected': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
        },
    },
}));

export const BillingIntervalToggle = ({ value, onChange }: BillingIntervalToggleProps) => {
    const { t } = useTranslation();
    return (
        <Stack alignItems="center">
            <ToggleButtonGroup
                value={value}
                exclusive
                onChange={(_, val) => val && onChange(val)}
                size="small"
            >
                <ToggleButton value={PlanPriceInterval.Month}>
                    {t('billing.calculator.interval.monthly')}
                </ToggleButton>
                <ToggleButton value={PlanPriceInterval.Year}>
                    {t('billing.calculator.interval.yearly')}
                    <Chip
                        size="small"
                        color="success"
                        label={`-${Math.round((1 - PLANS_YEARLY_DISCOUNT) * 100)}%`}
                        sx={{ ml: 1, height: 20, fontSize: '0.65rem', fontWeight: 700 }}
                    />
                </ToggleButton>
            </ToggleButtonGroup>
        </Stack>
    );
};
